import React, { useState } from 'react';
import { CalculatorIcon, DollarSignIcon, PercentIcon, BriefcaseIcon } from 'lucide-react';
export function MortgageTools() {
  // Mortgage Calc State
  const [loanAmount, setLoanAmount] = useState(400000);
  const [rate, setRate] = useState(6.5);
  const [term, setTerm] = useState(30);
  const [downPayment, setDownPayment] = useState(20);
  const [tax, setTax] = useState(4800);
  const [insurance, setInsurance] = useState(1200);
  // SE Calc State
  const [rev1, setRev1] = useState(150000);
  const [rev2, setRev2] = useState(180000);
  const [exp1, setExp1] = useState(40000);
  const [exp2, setExp2] = useState(45000);
  const [dep1, setDep1] = useState(5000);
  const [dep2, setDep2] = useState(5000);
  // Mortgage Calculations
  const principal = loanAmount - loanAmount * (downPayment / 100);
  const r = rate / 100 / 12;
  const n = term * 12;
  const pi = principal * (r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);
  const monthlyTax = tax / 12;
  const monthlyIns = insurance / 12;
  const totalPayment = pi + monthlyTax + monthlyIns;
  // SE Calculations
  const net1 = rev1 - exp1 + dep1;
  const net2 = rev2 - exp2 + dep2;
  const avgAnnual = (net1 + net2) / 2;
  const monthlyQualifying = avgAnnual / 12;
  return <div style={{
    maxWidth: 1280,
    margin: '0 auto'
  }} data-id="element-569">
      <div style={{
      marginBottom: 24
    }} data-id="element-570">
        <h2 style={{
        fontSize: 26,
        fontWeight: 900,
        color: '#1A2B3C',
        margin: '0 0 3px',
        fontStyle: 'italic',
        letterSpacing: '-0.04em'
      }} data-id="element-571">
          Mortgage Tools
        </h2>
        <p style={{
        fontSize: 13,
        color: '#5A6A8A',
        margin: 0
      }} data-id="element-572">
          Calculators for quick estimates and qualifying income
        </p>
      </div>

      <div style={{
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 24
    }} data-id="element-573">
        {/* Mortgage Calculator */}
        <div style={{
        background: '#FFFFFF',
        borderRadius: 12,
        padding: '24px',
        border: '1px solid #E4EAF6',
        borderTopWidth: 3,
        borderTopColor: '#2B8DC4',
        boxShadow: '0 2px 8px rgba(13,27,42,0.06)'
      }} data-id="element-574">
          <h3 style={{
          fontSize: 16,
          fontWeight: 900,
          color: '#1A2B3C',
          margin: '0 0 20px',
          fontStyle: 'italic',
          letterSpacing: '-0.02em',
          display: 'flex',
          alignItems: 'center',
          gap: 8
        }} data-id="element-575">
            <CalculatorIcon size={18} color="#2B8DC4" data-id="element-576" /> Payment Calculator
          </h3>

          <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 16,
          marginBottom: 24
        }} data-id="element-577">
            <div data-id="element-578">
              <label style={{
              display: 'block',
              fontSize: 11,
              fontWeight: 800,
              color: '#5A6A8A',
              textTransform: 'uppercase',
              marginBottom: 6
            }} data-id="element-579">
                Purchase Price
              </label>
              <div style={{
              position: 'relative'
            }} data-id="element-580">
                <DollarSignIcon size={14} style={{
                position: 'absolute',
                left: 10,
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#A0AECB'
              }} data-id="element-581" />
                <input type="number" value={loanAmount} onChange={e => setLoanAmount(Number(e.target.value))} style={{
                width: '100%',
                padding: '8px 12px 8px 30px',
                borderRadius: 8,
                border: '1px solid #E4EAF6',
                fontSize: 14,
                fontWeight: 600,
                color: '#1A2B3C',
                outline: 'none'
              }} data-id="element-582" />
              </div>
            </div>
            <div data-id="element-583">
              <label style={{
              display: 'block',
              fontSize: 11,
              fontWeight: 800,
              color: '#5A6A8A',
              textTransform: 'uppercase',
              marginBottom: 6
            }} data-id="element-584">
                Down Payment (%)
              </label>
              <div style={{
              position: 'relative'
            }} data-id="element-585">
                <PercentIcon size={14} style={{
                position: 'absolute',
                right: 10,
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#A0AECB'
              }} data-id="element-586" />
                <input type="number" value={downPayment} onChange={e => setDownPayment(Number(e.target.value))} style={{
                width: '100%',
                padding: '8px 30px 8px 12px',
                borderRadius: 8,
                border: '1px solid #E4EAF6',
                fontSize: 14,
                fontWeight: 600,
                color: '#1A2B3C',
                outline: 'none'
              }} data-id="element-587" />
              </div>
            </div>
            <div data-id="element-588">
              <label style={{
              display: 'block',
              fontSize: 11,
              fontWeight: 800,
              color: '#5A6A8A',
              textTransform: 'uppercase',
              marginBottom: 6
            }} data-id="element-589">
                Interest Rate (%)
              </label>
              <div style={{
              position: 'relative'
            }} data-id="element-590">
                <PercentIcon size={14} style={{
                position: 'absolute',
                right: 10,
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#A0AECB'
              }} data-id="element-591" />
                <input type="number" step="0.125" value={rate} onChange={e => setRate(Number(e.target.value))} style={{
                width: '100%',
                padding: '8px 30px 8px 12px',
                borderRadius: 8,
                border: '1px solid #E4EAF6',
                fontSize: 14,
                fontWeight: 600,
                color: '#1A2B3C',
                outline: 'none'
              }} data-id="element-592" />
              </div>
            </div>
            <div data-id="element-593">
              <label style={{
              display: 'block',
              fontSize: 11,
              fontWeight: 800,
              color: '#5A6A8A',
              textTransform: 'uppercase',
              marginBottom: 6
            }} data-id="element-594">
                Loan Term
              </label>
              <select value={term} onChange={e => setTerm(Number(e.target.value))} style={{
              width: '100%',
              padding: '8px 12px',
              borderRadius: 8,
              border: '1px solid #E4EAF6',
              fontSize: 14,
              fontWeight: 600,
              color: '#1A2B3C',
              outline: 'none',
              background: 'white'
            }} data-id="element-595">
                <option value={30} data-id="element-596">30 Years</option>
                <option value={20} data-id="element-597">20 Years</option>
                <option value={15} data-id="element-598">15 Years</option>
              </select>
            </div>
            <div data-id="element-599">
              <label style={{
              display: 'block',
              fontSize: 11,
              fontWeight: 800,
              color: '#5A6A8A',
              textTransform: 'uppercase',
              marginBottom: 6
            }} data-id="element-600">
                Annual Tax
              </label>
              <div style={{
              position: 'relative'
            }} data-id="element-601">
                <DollarSignIcon size={14} style={{
                position: 'absolute',
                left: 10,
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#A0AECB'
              }} data-id="element-602" />
                <input type="number" value={tax} onChange={e => setTax(Number(e.target.value))} style={{
                width: '100%',
                padding: '8px 12px 8px 30px',
                borderRadius: 8,
                border: '1px solid #E4EAF6',
                fontSize: 14,
                fontWeight: 600,
                color: '#1A2B3C',
                outline: 'none'
              }} data-id="element-603" />
              </div>
            </div>
            <div data-id="element-604">
              <label style={{
              display: 'block',
              fontSize: 11,
              fontWeight: 800,
              color: '#5A6A8A',
              textTransform: 'uppercase',
              marginBottom: 6
            }} data-id="element-605">
                Annual Insurance
              </label>
              <div style={{
              position: 'relative'
            }} data-id="element-606">
                <DollarSignIcon size={14} style={{
                position: 'absolute',
                left: 10,
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#A0AECB'
              }} data-id="element-607" />
                <input type="number" value={insurance} onChange={e => setInsurance(Number(e.target.value))} style={{
                width: '100%',
                padding: '8px 12px 8px 30px',
                borderRadius: 8,
                border: '1px solid #E4EAF6',
                fontSize: 14,
                fontWeight: 600,
                color: '#1A2B3C',
                outline: 'none'
              }} data-id="element-608" />
              </div>
            </div>
          </div>

          <div style={{
          padding: '20px',
          borderRadius: 12,
          background: '#F4F8FC',
          border: '1px solid #E4EAF6'
        }} data-id="element-609">
            <div style={{
            textAlign: 'center',
            marginBottom: 16
          }} data-id="element-610">
              <div style={{
              fontSize: 12,
              color: '#5A6A8A',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              marginBottom: 4
            }} data-id="element-611">
                Estimated Monthly Payment
              </div>
              <div style={{
              fontSize: 36,
              fontWeight: 900,
              color: '#1A2B3C',
              fontStyle: 'italic',
              letterSpacing: '-0.02em'
            }} data-id="element-612">
                ${totalPayment.toFixed(2)}
              </div>
            </div>

            <div style={{
            display: 'flex',
            height: 12,
            borderRadius: 6,
            overflow: 'hidden',
            marginBottom: 16
          }} data-id="element-613">
              <div style={{
              width: `${pi / totalPayment * 100}%`,
              background: '#2B8DC4'
            }} data-id="element-614" />
              <div style={{
              width: `${monthlyTax / totalPayment * 100}%`,
              background: '#1A2B3C'
            }} data-id="element-615" />
              <div style={{
              width: `${monthlyIns / totalPayment * 100}%`,
              background: '#1E6FA0'
            }} data-id="element-616" />
            </div>

            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: 12
          }} data-id="element-617">
              <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6
            }} data-id="element-618">
                <div style={{
                width: 10,
                height: 10,
                borderRadius: 3,
                background: '#2B8DC4'
              }} data-id="element-619" />
                <span style={{
                color: '#5A6A8A'
              }} data-id="element-620">
                  P&I:{' '}
                  <strong style={{
                  color: '#1A2B3C'
                }} data-id="element-621">
                    ${pi.toFixed(0)}
                  </strong>
                </span>
              </div>
              <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6
            }} data-id="element-622">
                <div style={{
                width: 10,
                height: 10,
                borderRadius: 3,
                background: '#1A2B3C'
              }} data-id="element-623" />
                <span style={{
                color: '#5A6A8A'
              }} data-id="element-624">
                  Tax:{' '}
                  <strong style={{
                  color: '#1A2B3C'
                }} data-id="element-625">
                    ${monthlyTax.toFixed(0)}
                  </strong>
                </span>
              </div>
              <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6
            }} data-id="element-626">
                <div style={{
                width: 10,
                height: 10,
                borderRadius: 3,
                background: '#1E6FA0'
              }} data-id="element-627" />
                <span style={{
                color: '#5A6A8A'
              }} data-id="element-628">
                  Ins:{' '}
                  <strong style={{
                  color: '#1A2B3C'
                }} data-id="element-629">
                    ${monthlyIns.toFixed(0)}
                  </strong>
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Self-Employment Calculator */}
        <div style={{
        background: '#FFFFFF',
        borderRadius: 12,
        padding: '24px',
        border: '1px solid #E4EAF6',
        borderTopWidth: 3,
        borderTopColor: '#1A2B3C',
        boxShadow: '0 2px 8px rgba(13,27,42,0.06)'
      }} data-id="element-630">
          <h3 style={{
          fontSize: 16,
          fontWeight: 900,
          color: '#1A2B3C',
          margin: '0 0 20px',
          fontStyle: 'italic',
          letterSpacing: '-0.02em',
          display: 'flex',
          alignItems: 'center',
          gap: 8
        }} data-id="element-631">
            <BriefcaseIcon size={18} color="#1A2B3C" data-id="element-632" /> Self-Employment Income
          </h3>

          <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 16,
          marginBottom: 24
        }} data-id="element-633">
            <div style={{
            gridColumn: '1 / -1',
            fontSize: 12,
            fontWeight: 800,
            color: '#1A2B3C',
            paddingBottom: 8,
            borderBottom: '1px solid #E4EAF6'
          }} data-id="element-634">
              Year 1 (Most Recent)
            </div>
            <div data-id="element-635">
              <label style={{
              display: 'block',
              fontSize: 11,
              fontWeight: 800,
              color: '#5A6A8A',
              textTransform: 'uppercase',
              marginBottom: 6
            }} data-id="element-636">
                Gross Revenue
              </label>
              <div style={{
              position: 'relative'
            }} data-id="element-637">
                <DollarSignIcon size={14} style={{
                position: 'absolute',
                left: 10,
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#A0AECB'
              }} data-id="element-638" />
                <input type="number" value={rev1} onChange={e => setRev1(Number(e.target.value))} style={{
                width: '100%',
                padding: '8px 12px 8px 30px',
                borderRadius: 8,
                border: '1px solid #E4EAF6',
                fontSize: 14,
                fontWeight: 600,
                color: '#1A2B3C',
                outline: 'none'
              }} data-id="element-639" />
              </div>
            </div>
            <div data-id="element-640">
              <label style={{
              display: 'block',
              fontSize: 11,
              fontWeight: 800,
              color: '#5A6A8A',
              textTransform: 'uppercase',
              marginBottom: 6
            }} data-id="element-641">
                Expenses
              </label>
              <div style={{
              position: 'relative'
            }} data-id="element-642">
                <DollarSignIcon size={14} style={{
                position: 'absolute',
                left: 10,
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#A0AECB'
              }} data-id="element-643" />
                <input type="number" value={exp1} onChange={e => setExp1(Number(e.target.value))} style={{
                width: '100%',
                padding: '8px 12px 8px 30px',
                borderRadius: 8,
                border: '1px solid #E4EAF6',
                fontSize: 14,
                fontWeight: 600,
                color: '#1A2B3C',
                outline: 'none'
              }} data-id="element-644" />
              </div>
            </div>
            <div style={{
            gridColumn: '1 / -1'
          }} data-id="element-645">
              <label style={{
              display: 'block',
              fontSize: 11,
              fontWeight: 800,
              color: '#5A6A8A',
              textTransform: 'uppercase',
              marginBottom: 6
            }} data-id="element-646">
                Depreciation (Add-back)
              </label>
              <div style={{
              position: 'relative'
            }} data-id="element-647">
                <DollarSignIcon size={14} style={{
                position: 'absolute',
                left: 10,
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#A0AECB'
              }} data-id="element-648" />
                <input type="number" value={dep1} onChange={e => setDep1(Number(e.target.value))} style={{
                width: '100%',
                padding: '8px 12px 8px 30px',
                borderRadius: 8,
                border: '1px solid #E4EAF6',
                fontSize: 14,
                fontWeight: 600,
                color: '#1A2B3C',
                outline: 'none'
              }} data-id="element-649" />
              </div>
            </div>

            <div style={{
            gridColumn: '1 / -1',
            fontSize: 12,
            fontWeight: 800,
            color: '#1A2B3C',
            paddingBottom: 8,
            borderBottom: '1px solid #E4EAF6',
            marginTop: 8
          }} data-id="element-650">
              Year 2 (Previous)
            </div>
            <div data-id="element-651">
              <label style={{
              display: 'block',
              fontSize: 11,
              fontWeight: 800,
              color: '#5A6A8A',
              textTransform: 'uppercase',
              marginBottom: 6
            }} data-id="element-652">
                Gross Revenue
              </label>
              <div style={{
              position: 'relative'
            }} data-id="element-653">
                <DollarSignIcon size={14} style={{
                position: 'absolute',
                left: 10,
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#A0AECB'
              }} data-id="element-654" />
                <input type="number" value={rev2} onChange={e => setRev2(Number(e.target.value))} style={{
                width: '100%',
                padding: '8px 12px 8px 30px',
                borderRadius: 8,
                border: '1px solid #E4EAF6',
                fontSize: 14,
                fontWeight: 600,
                color: '#1A2B3C',
                outline: 'none'
              }} data-id="element-655" />
              </div>
            </div>
            <div data-id="element-656">
              <label style={{
              display: 'block',
              fontSize: 11,
              fontWeight: 800,
              color: '#5A6A8A',
              textTransform: 'uppercase',
              marginBottom: 6
            }} data-id="element-657">
                Expenses
              </label>
              <div style={{
              position: 'relative'
            }} data-id="element-658">
                <DollarSignIcon size={14} style={{
                position: 'absolute',
                left: 10,
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#A0AECB'
              }} data-id="element-659" />
                <input type="number" value={exp2} onChange={e => setExp2(Number(e.target.value))} style={{
                width: '100%',
                padding: '8px 12px 8px 30px',
                borderRadius: 8,
                border: '1px solid #E4EAF6',
                fontSize: 14,
                fontWeight: 600,
                color: '#1A2B3C',
                outline: 'none'
              }} data-id="element-660" />
              </div>
            </div>
            <div style={{
            gridColumn: '1 / -1'
          }} data-id="element-661">
              <label style={{
              display: 'block',
              fontSize: 11,
              fontWeight: 800,
              color: '#5A6A8A',
              textTransform: 'uppercase',
              marginBottom: 6
            }} data-id="element-662">
                Depreciation (Add-back)
              </label>
              <div style={{
              position: 'relative'
            }} data-id="element-663">
                <DollarSignIcon size={14} style={{
                position: 'absolute',
                left: 10,
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#A0AECB'
              }} data-id="element-664" />
                <input type="number" value={dep2} onChange={e => setDep2(Number(e.target.value))} style={{
                width: '100%',
                padding: '8px 12px 8px 30px',
                borderRadius: 8,
                border: '1px solid #E4EAF6',
                fontSize: 14,
                fontWeight: 600,
                color: '#1A2B3C',
                outline: 'none'
              }} data-id="element-665" />
              </div>
            </div>
          </div>

          <div style={{
          padding: '20px',
          borderRadius: 12,
          background: '#1A2B3C',
          color: 'white'
        }} data-id="element-666">
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end'
          }} data-id="element-667">
              <div data-id="element-668">
                <div style={{
                fontSize: 12,
                color: 'rgba(255,255,255,0.6)',
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                marginBottom: 4
              }} data-id="element-669">
                  Monthly Qualifying Income
                </div>
                <div style={{
                fontSize: 32,
                fontWeight: 900,
                color: 'white',
                fontStyle: 'italic',
                letterSpacing: '-0.02em'
              }} data-id="element-670">
                  ${monthlyQualifying.toFixed(2)}
                </div>
              </div>
              <div style={{
              textAlign: 'right'
            }} data-id="element-671">
                <div style={{
                fontSize: 11,
                color: 'rgba(255,255,255,0.6)',
                marginBottom: 2
              }} data-id="element-672">
                  Annual Average
                </div>
                <div style={{
                fontSize: 14,
                fontWeight: 800,
                color: '#2B8DC4'
              }} data-id="element-673">
                  ${avgAnnual.toFixed(2)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}